"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUrlRedirect = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var handleUrlRedirect = function handleUrlRedirect(location) {
  var _queryString$parse = _queryString["default"].parse(location.search),
      redirect = _queryString$parse.redirect;

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirect || '/dashboard'
  });
};

exports.handleUrlRedirect = handleUrlRedirect;